import React, { Fragment } from 'react';
import 'antd/dist/antd.css';
import './App.css';
import { connect } from 'react-redux';
import { compose, lifecycle, withHandlers, withState } from 'recompose';
import {
  Layout,
  Form,
  Input,
  Radio,
  Progress,
  Button,
  Row,
  Col,
  Icon,
  Upload,
  message,
  Modal,
  DatePicker,
  Select
} from 'antd';
import { URL, cpfFormater, onlyNumbers, phoneFormater, clearCharacters } from './utility/utils';
import GetTokenForm, { formReference } from './components/GetTokenForm';
import Token from './utility/token';
import { redirect } from './ducks/Application';
import { getStorageLocal, formSubmit } from './ducks/User';
import { passwordConfirmation, validateUserPasswordPowerResponse } from './ducks/inputValidations';
import { userPasswordValidation, userCpfValidation, passwordConfirmation as userPasswordConfirmation } from './integrations/InputValidationsAPI';

import locale from 'antd/lib/date-picker/locale/pt_BR';
import SuccessFormSubmitMessage from "./components/SuccessFormSubmitMessage";

const RadioGroup = Radio.Group;
const App = ({
  handleSubmit,
  form,
  token,
  setToken,
  loadingImage,
  beforeUpload,
  callValidateUserPasswordPowerResponse,
  handleImageChange,
  userData,
  GetTokenFormSubmitHandler,
  onCpfBlurHandler,
  onCpfChangeHandler,
  clearCharactersOnFocus,
  inputValidationsData,
  onPasswordChangeHandler,
  showSuccessMessage
}) => {
  const FormItem = Form.Item;
  const { getFieldDecorator } = form;
  const uploadButton = (
    <div>
      <Icon type={loadingImage ? 'loading' : 'plus'} />
      <div className="ant-upload-text">Escolha uma imagem</div>
    </div>
  );
  const Option = Select.Option;
  let disableForm = typeof token !== 'string' && !token.length;

  if (userData.formSubmit.data !== null && userData.formSubmit.data.login) {
    showSuccessMessage(userData.formSubmit.data);
  }

  return (
    <Fragment>
      <Modal
        visible={token === false}
        title="Token de acesso"
        closable={false}
        footer={[
          <Button key="submit" type="primary" onClick={GetTokenFormSubmitHandler}>
            Submit
                    </Button>,
        ]}
      >
        <GetTokenForm></GetTokenForm>
      </Modal>
      <Layout className="vn-small-wrapper">
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col>
              <FormItem style={{ textAlign: 'center' }} label="Faça o upload de sua foto">
                <Upload
                  name="avatar"
                  listType="picture-card"
                  className="avatar-uploader"
                  accept=".jpg, .png, .jpeg, .gif"
                  showUploadList={false}
                  action="https://app.vianuvem.com.br"
                  beforeUpload={() => false}
                  onChange={handleImageChange}
                >
                  {userData.avatar.avatarUrl ? <img style={{ maxWidth: '150px' }} src={userData.avatar.avatarUrl} alt="avatar" /> : uploadButton}
                </Upload>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormItem
                label="Nome completo"
              >
                {
                  getFieldDecorator('fullName', {
                    rules: [
                      { required: true, message: 'Digite seu nome completo.' }
                    ]
                  })(
                    <Input
                      disabled={disableForm}
                      prefix={<Icon type="user" theme="outlined" />} />
                  )
                }
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col xs={24} md={12}>
              <FormItem
                label="CPF"
                hasFeedback={true}
              >
                {
                  getFieldDecorator('cpf', {
                    rules: [
                      {
                        required: true, message: 'Por favor informe seu CPF!',
                        min: 11,
                        max: 14
                      },
                      {
                        validator: (rule, value, callback, source, options) => {
                          const errors = [];

                          if (value.length >= 11) {
                            userCpfValidation({ cpf: value, token })
                              .then(() => {
                                callback(errors);
                              })
                              .catch(error => {
                                errors.push(error);
                                callback(errors);
                              });
                          }
                        }
                      }
                    ]
                  })(
                    <Input
                      disabled={disableForm}
                      onChange={onCpfChangeHandler}
                      onBlur={onCpfBlurHandler}
                      onFocus={clearCharactersOnFocus}
                      prefix={<Icon type="idcard" theme="outlined" />} />
                  )
                }
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col xs={24} md={8}>
              <FormItem
                label="Tipo"
              >
                {
                  getFieldDecorator('sequence', { initialValue: "3" })(
                    <Select>
                      {/*<Option value="1">Residencial</Option>
                      <Option value="2">Comercial</Option>*/}
                      <Option value="3">Celular</Option>
                    </Select>
                  )
                }
              </FormItem>
            </Col>
            <Col xs={24} md={12}>
              <FormItem
                label="Número"
              >
                {
                  getFieldDecorator('cellphone', {
                    rules: [{
                      required: true, message: 'Por favor informe seu celular!',
                      min: 10,
                    }]
                  })(
                    <Input
                      disabled={disableForm}
                      onChange={onlyNumbers}
                      onBlur={phoneFormater}
                      onFocus={clearCharactersOnFocus}
                      maxLength={11}
                      placeholder="ex: (11) 93333-5555"
                      prefix={<Icon type="phone" theme="outlined" />} />
                  )
                }
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col xs={24} md={12}>
              <FormItem
                label="Data nascimento"
              >
                {
                  getFieldDecorator('birthday', {
                    rules: [
                      {
                        required: true, message: 'Por favor selecione sua data de nascimento!'
                      }
                    ]
                  })(
                    <DatePicker format="DD/MM/YYYY" locale={locale} />
                  )
                }
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormItem
                label="Sexo"
              >
                {
                  getFieldDecorator('sex', {
                    rules: [{
                      required: true, message: 'Por favor informe seu sexo!',
                    }]
                  })(
                    <RadioGroup>
                      <Radio value="M" checked={true}>Masculino</Radio>
                      <Radio value="F">Feminino</Radio>
                    </RadioGroup>
                  )
                }
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormItem
                label="Senha"
                hasFeedback={true}
                className="--has-progress"
              >
                {
                  getFieldDecorator('password', {
                    rules: [
                      { required: true, message: 'Digite uma senha para prosseguir.' },
                      {
                        validator: (rule, value, callback, source, options) => {
                          const errors = [];
                          userPasswordValidation.init(value).then(result => {
                            callValidateUserPasswordPowerResponse(result);
                            if (result.status !== 'active') {
                              errors.push(result.message);
                            }
                            callback(errors);
                          });
                        }
                      }
                    ]
                  })(
                    <Input
                      disabled={disableForm}
                      type="password"
                      prefix={<Icon type="lock" theme="outlined" />} />
                  )
                }
                <Progress
                  className='vn-password-power'
                  percent={inputValidationsData.password.power}
                  status={inputValidationsData.password.status}
                  format={() => ''} />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormItem
                label="Confirmar Senha"
                hasFeedback={true}
              >
                {
                  getFieldDecorator('passwordConfirmation', {
                    rules: [
                      { required: true, message: 'Confirme a senha!' },
                      {
                        validator: (rule, value, callback, source, options) => {
                          const errors = [];
                          const passwordValue = form.getFieldValue('password');
                          userPasswordConfirmation({ password: passwordValue, confirmation: value })
                            .then(confirmation => {
                              if (confirmation !== true) {
                                errors.push(confirmation);
                              }
                              callback(errors);
                            })
                            .catch(error => {
                              errors.push(error);
                              callback(errors);
                            });
                        }
                      }
                    ]
                  })(
                    <Input
                      disabled={disableForm}
                      type="password"
                      prefix={<Icon type="lock" theme="outlined" />} />
                  )
                }
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormItem style={{ textAlign: 'right' }}>
                <Button disabled={disableForm} loading={userData.formSubmit.loading} type="primary" htmlType="submit">Salvar</Button>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Layout>
    </Fragment>
  );
};

export default compose(
  Form.create(null, { validateTrigger: 'onKeyup' }),
  connect(({ userData, inputValidationsData }) => {
    return {
      userData,
      inputValidationsData
    }
  }, (dispatch) => {
    return {
      callGetStorageLocal(data) {
        dispatch(getStorageLocal(data));
      },
      callValidateUserPasswordPowerResponse(result) {
        dispatch(validateUserPasswordPowerResponse(result));
      },
      callPasswordConfirmation(password, pwConfirmation) {
        dispatch(passwordConfirmation({ password, confirmation: pwConfirmation }))
      },
      callFormSubmit(data) {
        dispatch(formSubmit(data));
      }
    }
  }),
  withState('token', 'setToken', true),
  withState('initialized', 'setInitialized', false),
  withHandlers({
    initialize: ({ initialData, callInjectSessions, setInitialized, setToken }) => () => {
      if (initialData) {
        setInitialized(true);
      }
      const urlToken = URL.getUrlParam('token');
      if (urlToken) {
        Token.validate(urlToken)
          .then(() => {
            setToken(urlToken)
          })
          .catch(error => {
            message.error(error);
            setToken(false);
          })
      } else {
        setToken(false);
      }
    },
    handleSubmit: ({ form, userData, token, callFormSubmit }) => (e) => {
      e.preventDefault();

      form.validateFields((err, values) => {
        if (!err) {
          let storageLocal = '';

          if (userData.avatar.storageLocal) {
            storageLocal = userData.avatar.storageLocal;
          }

          callFormSubmit({ ...values, photo: storageLocal, token });
        }
      });
    },
    handleImageChange: ({ token, callGetStorageLocal }) => (data) => {
      const fileNameSplitted = data.file.name.split('.');
      const extension = fileNameSplitted[fileNameSplitted.length - 1];

      const isLt5M = data.file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        message.error('A sua foto deve ter no máximo 5MB!');
      }
      else {
        callGetStorageLocal({ extension, token, file: data.file });
      }
    },
    GetTokenFormSubmitHandler: ({ setToken }) => (data) => {
      if (formReference) {
        formReference.validateFields((err, values) => {
          if (!err) {
            Token.validate(values.token)
              .then(data => {
                setToken(values.token)
              })
              .catch(error => {
                message.error(error)
              })
          }
        });
      }
    },
    onCpfChangeHandler: (props) => (e) => {
      onlyNumbers(e, 11);
    },
    onCpfBlurHandler: (props) => (e) => {
      onlyNumbers(e);
      clearCharacters(e);
      cpfFormater(e);
    },
    onPasswordChangeHandler: (props) => (e) => {
      props.form.setFieldsValue({ passwordConfirmation: '' });
    },
    clearCharactersOnFocus: (props) => (e) => {
      clearCharacters(e);
    },
    showSuccessMessage: ({ userData }) => (successUserData) => {
      Modal.success({
        title: `Parabéns ${successUserData.name}`,
        content: <SuccessFormSubmitMessage userData={successUserData} />,
        onOk: () => {
          if (userData.formSubmit.redirectUrl) {
            window.parent.postMessage(
              redirect('https://' + userData.formSubmit.redirectUrl),
              '*'
            );
          }
        }
      });
    }
  }),
  lifecycle({
    componentDidUpdate() {
      if (!this.props.initialized) {
        this.props.initialize();
      }

    },
    componentDidMount() {
      const {
        initialize
      } = this.props;

      if (!this.props.initialized) {
        initialize();
      }
    }
  })
)(App);



// WEBPACK FOOTER //
// ./src/App.js